<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Title</label>
          <v-text-field v-model="fields.title" label="Title" />
        </div>
        <div>
          <div class="mb-4 d-flex align-center">
            <label for="border-enabled" class="label-input mr-3 mb-0" style="margin-bottom: 0"
              >Enable Wrap Border</label
            >
            <input type="checkbox" v-model="fields['border-enabled']" id="border-enabled" />
          </div>
          <v-text-field v-model="fields['border-weight']" label="Border Weight (e.g. 2px or 2)"></v-text-field>
        </div>
        <div>
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label style="margin-bottom: 0" class="label-input">Items</label>
            </div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['accordions']['listItem']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Item {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="">
                  <div>
                    <v-text-field v-model="item.title" label="Title" />
                  </div>
                  <div class="mb-6">
                    <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                      <label for="showBtn" style="margin-bottom: 0">Image</label>
                      <input type="checkbox" v-model="item.enableImage" id="showBtn" />
                    </div>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.imageContent }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                  <div>
                    <label>Description:</label>
                    <ckeditor :editor="editor" v-model="item.textContent" :config="editorConfig" />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <SectionPadding
              class="mb-6"
              :fields="fields.sectionPadding"
              :reset-padding="{ topDesktop: 16, bottomDesktop: 0, topMobile: 16, bottomMobile: 0 }"
            />
            <div class="mt-6">
              <div class="font-weight-medium mb-3">Container Colors</div>
              <v-row>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['title-color']"
                    name="title-color"
                    label="Title Color"
                    default-color="#000000"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['border-color']"
                    name="border-color"
                    label="Border Color"
                    default-color="#000000"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import ColorPicker from './common/color-picker.vue';
import SectionPadding from './common/section-padding.vue';
import { replaceImageUrl } from '../common/utils';

export default {
  name: 'hurrybox-sizing-chart',
  components: {
    UploadImage,
    ColorPicker,
    SectionPadding,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        accordions: {
          listItem: [
            // {
            //   title: '',
            //   textContent: '',
            //   imageContent: '',
            //   enableImage: false,
            // },
          ],
        },
        'border-color': '#000000',
        'border-weight': '2px',
        'border-enabled': true,
        'title-color': '#000000',
        sectionPadding: {
          topDesktop: 16,
          bottomDesktop: 0,
          topMobile: 16,
          bottomMobile: 0,
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields['accordions']['listItem'].push({
        title: 'Sizing Chart',
        textContent: `<p style="text-align:center;"><span><strong>*Size down for STRONGER compression*</strong></span></p>`,
        imageContent: replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2025/10/27/image-68ff3d7dd4c704ee388cd8b4.webp?w=600&h=50&q=80',
        ),
        enableImage: true,
      });
    },
    handleRemoveItem(index) {
      this.fields['accordions']['listItem'].splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields['accordions']['listItem'][index].imageContent = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields['accordions']['listItem'][index].imageContent = '';
      this.fields['accordions']['listItem'][index].enableImage = false;
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSizingChartHurryBox(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
